import { render } from "./HiAttachment.vue?vue&type=template&id=76ca9bc6&scoped=true"
import script from "./HiAttachment.vue?vue&type=script&lang=js"
export * from "./HiAttachment.vue?vue&type=script&lang=js"

import "./HiAttachment.vue?vue&type=style&index=0&id=76ca9bc6&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76ca9bc6"]])

export default __exports__